var _circle, _g, _g2, _line, _line2, _line3, _line4, _line5, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    stroke: "currentColor",
    strokeWidth: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 547.9,
    cy: 770.7,
    r: 71.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M491.2,532.8L491.2,532.8c-30.6-30.6-44-74.5-35.7-117c13-66.4,43.9-165.4,117.4-238.9 C693.9,56,800.3,68.7,877.8,146.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.2,532.8L491.2,532.8c30.6,30.6,74.5,44,117,35.7c66.4-13,165.4-43.9,238.9-117.4 C968,330.1,955.3,223.7,877.8,146.2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M455.6,415.7c-17.3,75.3-39.7,192.3-111.5,264.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.3,568.4c-75.3,17.3-191.6,39-264.1,111.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.1,
    y1: 679.9,
    x2: 305.8,
    y2: 718.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.3,930.3l-23.6-23.6c-8.9-8.9-8.9-23.4,0-32.3l125.8-125.8c8.2-8.2,18.4-14.4,29.5-17.8 c17.2-5.3,43-12.5,56.8-12.5l0,0c0,13.7-7.2,39.5-12.5,56.8c-3.5,11.1-9.6,21.3-17.8,29.5L149.6,930.3 C140.7,939.2,126.2,939.2,117.3,930.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 750.9,
    y1: 89.7,
    x2: 470.6,
    y2: 370
  }), /*#__PURE__*/React.createElement("line", {
    x1: 839,
    y1: 123.9,
    x2: 470.5,
    y2: 492.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900.1,
    y1: 185,
    x2: 531.7,
    y2: 553.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 934.3,
    y1: 273.1,
    x2: 654,
    y2: 553.4
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 698.7,
    y1: 104.7,
    x2: 918.4,
    y2: 324.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 598.4,
    y1: 164.6,
    x2: 859.4,
    y2: 425.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 527.2,
    y1: 253.6,
    x2: 770.3,
    y2: 496.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 366.6,
    x2: 658.3,
    y2: 544.9
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 213.9,
    y1: 754.2,
    x2: 269.8,
    y2: 810.1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 127.9,
    y1: 840.2,
    x2: 183.8,
    y2: 896.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquash);
export default __webpack_public_path__ + "static/media/Squash.7b357e1fbb8df45a7d1fc5159bc12fb6.svg";
export { ForwardRef as ReactComponent };